/**
 * Helpers purs de la page Reglages -> Profil.
 * Ni React, ni instance i18next : importables depuis les tests unitaires
 * sans monter la page (meme pattern que preSignatureRows.js / billingPanel.js).
 */

/**
 * Workspaces qui empechent la suppression du compte : ceux que l'utilisateur
 * possede ET qui comptent d'autres membres.
 *
 * Miroir cote client de l'etape 1 de delete_account (backend/routes/auth.py).
 * L'autorite reste le serveur — ceci ne sert qu'a expliquer le blocage AVANT
 * que l'utilisateur ne remplisse un formulaire pour rien. En cas de doute
 * (member_count absent), on ne bloque pas : le 409 tranchera.
 */
export function blockingWorkspaces(workspaces, userId) {
  if (!Array.isArray(workspaces) || !userId) return [];
  return workspaces
    .filter((w) => w && w.role === "owner" && Number(w.member_count) > 1)
    .map((w) => ({ id: w.id, name: w.name }));
}

export function canDeleteAccount(workspaces, userId) {
  return blockingWorkspaces(workspaces, userId).length === 0;
}

/**
 * Date d'inscription lisible, ou null si la valeur est absente ou illisible.
 * Renvoyer null (plutot que "Invalid Date") laisse l'appelant masquer la
 * ligne entiere.
 */
export function formatMemberSince(iso, locale) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return new Intl.DateTimeFormat(locale === "en" ? "en-CA" : "fr-CA", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(d);
}
